module.exports = __webpack_public_path__ + "img/consumer.5354eb7c.svg";